// ============================================================
// VCS.Chat — Kern-Modul des Chat-Systems
// - WebSocket-Event-Dispatcher fuer Chat-Events
// - Text-Formatierung (Markdown, Links, Emojis)
// - Chat-Liste rendern, sortieren, filtern
// - Ungelesen-Zaehler, Preview-Updates
// - Gemeinsame Utilities fuer alle Chat-Submodule
// ============================================================
window.VCS = window.VCS || {};

VCS.Chat = class {

    // ── Konstanten ───────────────────────────────────────────

    static API_BASE = location.origin + '/api';
    static BOT_PHONE = '+493034359156';
    static BOT_NAME = 'Bernoria Concierge';
    static BOT_AVATAR = 'bc97fde7785bd1ba';

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {};
    }

    // ── Öffentliche Methoden ─────────────────────────────────

    peerPhone(chat) {
        return chat.participant1 === VCS.state.chatMyPhone ? chat.participant2 : chat.participant1;
    }

    formatTime(ts) {
        const d = new Date(ts);
        return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
    }

    // WhatsApp-style time/date for chat-list rows.
    // - Today        -> HH:MM
    // - Yesterday    -> i18n 'chatYesterday'
    // - Within 7 d   -> short weekday (locale)
    // - Older        -> full date (locale)
    // Compares on calendar-day basis, not on 24h delta.
    formatChatListTime(ts) {
        const d = new Date(ts);
        const now = new Date();
        const today     = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(today.getTime() - 86400000);
        const weekStart = new Date(today.getTime() - 6 * 86400000);
        const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());

        if (day.getTime() === today.getTime())     return this.formatTime(ts);
        if (day.getTime() === yesterday.getTime()) return t('chatYesterday') || 'Gestern';

        const localeMap = {
            de: 'de-DE',
            en: 'en-US',
            ru: 'ru-RU',
            fr: 'fr-FR',
            es: 'es-ES',
            it: 'it-IT',
            pt: 'pt-PT'
        };
        const lang = localeMap[VCS.state.currentLang] || VCS.state.currentLang || 'de-DE';

        if (day.getTime() >= weekStart.getTime()) {
            return d.toLocaleDateString(lang, { weekday: 'short' });
        }
        return d.toLocaleDateString(lang);
    }

    formatDate(ts) {
        const d = new Date(ts);
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(today.getTime() - 86400000);
        const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());

        if (day.getTime() === today.getTime()) {
            return t('chatToday');
        }
        if (day.getTime() === yesterday.getTime()) {
            return t('chatYesterday');
        }
        const localeMap = {
            de: 'de-DE',
            en: 'en-US',
            ru: 'ru-RU',
            fr: 'fr-FR',
            es: 'es-ES',
            it: 'it-IT',
            pt: 'pt-PT'
        };
        return d.toLocaleDateString(localeMap[VCS.state.currentLang] || VCS.state.currentLang, {
            day  : 'numeric',
            month: 'short',
            year : d.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
    }

    formatDuration(ms) {
        const sec = Math.round((ms || 0) / 1000);
        const m = Math.floor(sec / 60);
        const s = sec % 60;
        return m + ':' + s.toString().padStart(2, '0');
    }

    avatarHtml(initial, avatarHash, extraClass) {
        const cls = extraClass ? `chat-list-avatar-img ${extraClass}` : 'chat-list-avatar-img';
        if (avatarHash) {
            return { html: `<img src="${VCS.Chat.API_BASE}/profile/avatar/${avatarHash}" alt="" class="${cls}">`, hasAvatar: true };
        }
        return { html: initial || '?', hasAvatar: false };
    }

    openAvatarViewer(name, avatarHash) {
        const overlay = $('#avatarViewerOverlay')[0];
        const img = $('#avatarViewerImg')[0];
        const nameEl = $('#avatarViewerName')[0];
        if (!overlay || !img) return;
        nameEl && (nameEl.textContent = name || '');
        img.src = VCS.Chat.API_BASE + '/profile/avatar/' + avatarHash;
        overlay.classList.remove('hidden');
    }

    closeAvatarViewer() {
        const overlay = $('#avatarViewerOverlay')[0];
        if (overlay) {
            overlay.classList.add('hidden');
            const img = $('#avatarViewerImg')[0];
            if (img) img.src = '';
        }
    }

    normalizePhone(raw) {
        if (!raw) {
            return '';
        }
        // Nur + und Ziffern behalten, Leerzeichen/Bindestriche etc. entfernen
        let phone = raw.replace(/[^\d+]/g, '');

        // 00xx... → +xx...
        if (phone.startsWith('00')) {
            phone = '+' + phone.slice(2);
        }

        // Lokale Nummer (beginnt mit 0, kein +) → Ländervorwahl anhand Browser-Locale
        if (phone.startsWith('0') && !phone.startsWith('+')) {
            const countryByLocale = {
                de: '49', at: '43', ch: '41',
                ru: '7',  ua: '380',
                us: '1',  gb: '44', fr: '33', it: '39', es: '34',
                pl: '48', nl: '31', be: '32', pt: '351', se: '46',
                tr: '90', cz: '420', sk: '421', hu: '36', ro: '40'
            };
            const locale = (navigator.language || 'de').split('-').pop().toLowerCase();
            const code = countryByLocale[locale] || '49';
            phone = '+' + code + phone.slice(1);
        }

        // Ohne + beginnt → + voranstellen (User hat Ländercode ohne + eingegeben)
        if (!phone.startsWith('+') && phone.length > 6) {
            phone = '+' + phone;
        }

        // Führende 0 nach Ländervorwahl entfernen: +490172... → +49172...
        const m = phone.match(/^\+(\d{1,3})0(\d+)$/);
        if (m) {
            const withoutZero = '+' + m[1] + m[2];
            if (withoutZero.length >= 10) {
                phone = withoutZero;
            }
        }

        // Validierung: + gefolgt von 7-15 Ziffern
        if (!/^\+\d{7,15}$/.test(phone)) {
            return '';
        }

        return phone;
    }

    updateLangOnBackend() {
        if (!VCS.state.chatRegistered || !VCS.state.chatMyPhone) {
            return;
        }
        fetch(VCS.Chat.API_BASE + '/update-profile', {
            method : 'POST',
            headers: VCS.chat?.authHeaders({'Content-Type': 'application/json'}),
            body   : JSON.stringify({
                phoneNumber: VCS.state.chatMyPhone,
                displayName: VCS.state.chatMyName || ($('#regNameInput')[0]?.value || '').trim(),
                lang       : VCS.state.currentLang
            })
        }).catch(e => console.warn('[chat] lang update failed:', e));
    }

    notifySwPhone() {
        if (!VCS.state.chatMyPhone || !('serviceWorker' in navigator)) {
            return;
        }
        navigator.serviceWorker.ready.then(reg => {
            if (reg.active) {
                reg.active.postMessage({
                    type : 'set-phone',
                    phone: VCS.state.chatMyPhone
                });
            }
        });
    }

    static isBotChat(chatId) {
        return chatId && chatId.includes(VCS.Chat.BOT_PHONE);
    }

    authHeaders(extra = {}) {
        const h = { ...extra };
        if (VCS.state.chatAuthToken) {
            h['Authorization'] = 'Bearer ' + VCS.state.chatAuthToken;
        } else if (VCS.state.chatMyPhone) {
            h['x-phone'] = VCS.state.chatMyPhone;
        }
        return h;
    }

    wsSend(obj) {
        VCS.signaling?.send(obj);
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        // Platzhalter
    }
};
